<app-spinner *ngIf="topLoading$"></app-spinner>
